const fs = require("fs");
const nconf = require("nconf");
const tokens = require("./preval/tokens.preval");
const Immutable = require("immutable");
const { writeFile } = require("./helpers/outputHelper");

const tokenSets = Immutable.fromJS(tokens || {});

const tokensByCategory = tokenSets
  .flatMap((set) => set.getIn(["tokens", "props"]))
  .filter((token) => token.get("scope") !== "component")
  .filter((token) => token.get("deprecated") !== true)
  .reduce(
    (tokens, token) => tokens.set(token.get("name"), token),
    Immutable.Map()
  )
  .reduce(
    (categories, token) =>
      categories.update(token.get("category"), (tokens) =>
        tokens ? tokens.push(token) : Immutable.List.of(token)
      ),
    Immutable.Map()
  )
  // Sort alphanumerically
  .map((tokenCategory) =>
    tokenCategory.sort((token1, token2) =>
      token1.get("name").localeCompare(token2.get("name"), undefined, {
        numeric: true,
        sensitivity: "base",
      })
    )
  );

nconf.argv();
const generateToFile = nconf.get("to-file");
const tokensData = JSON.stringify(tokenSets);

const writeTokenFile = (data) => {
  writeFile(data, "tokens.json");
};

const generate = (data, toFile) => {
  if (!toFile) {
    console.log(data);
  }
  return toFile ? writeTokenFile(data) : data;
};

// Export the function writeFile as default
module.exports = generate(tokensData, generateToFile);